module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-up-cbff81f4.svg";